var map = {
	"./BNP_Samodzielniak_18_A.mp3": "b3bf",
	"./BNP_Samodzielniak_18_B.mp3": "e561",
	"./BNP_Samodzielniak_18_C.mp3": "8c74",
	"./BNP_Samodzielniak_18_D.mp3": "91a3",
	"./BNP_Samodzielniak_18_E.mp3": "bfc8",
	"./BNP_Samodzielniak_18_F.mp3": "c55b",
	"./BNP_Samodzielniak_18_G.mp3": "dff6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4040";